module.exports = __webpack_public_path__ + "static/media/td_diseño.358d7e5d.svg";